import { CampaignAudience, CampaignAudienceHelp } from 'models/campaign-mkt';

export const campaignAudienceHelp: Record<
  CampaignAudience,
  CampaignAudienceHelp
> = {
  Calouros: {
    title: 'Calouros',
    sections: [
      {
        title: 'Calouro padrão',
        paragraphs: [
          'Estudantes recém-ingressos ou em fase de ingresso na instituição. A campanha deve atuar principalmente no momento da matrícula, aceite da vaga, início do semestre e ambientação acadêmica.',
          'O objetivo é apresentar o crédito educacional como apoio preventivo, antes que a dificuldade financeira se transforme em inadimplência, desistência ou não efetivação da matrícula.',
        ],
      },
      {
        title: 'Calouro em evasão com débito',
        paragraphs: [
          'Estudantes que ingressaram recentemente, mas interromperam o vínculo com a instituição e deixaram pendências financeiras. A campanha deve ser trabalhada em conjunto com as áreas financeira, relacionamento e/ou retenção da IE.',
          'O foco é apresentar uma alternativa de reorganização financeira e retomada dos estudos, avaliando se o crédito educacional pode viabilizar o retorno acadêmico e a regularização do vínculo.)',
        ],
      },
      {
        title: 'Calouro em evasão sem débito',
        paragraphs: [
          'Estudantes que ingressaram, mas desistiram ou não deram continuidade ao curso sem deixar pendências financeiras. A campanha deve ser trabalhada com foco em reengajamento, destacando acolhimento, possibilidade de retorno e condições de apoio para permanência.',
          'Como não há débito, a barreira principal pode estar ligada a adaptação, renda, escolha de curso ou insegurança financeira; por isso, a comunicação deve ser menos voltada à cobrança e mais voltada à retomada da jornada acadêmica.',
        ],
      },
    ],
  },
  Veteranos: {
    title: 'Veteranos',
    sections: [
      {
        title: 'Veteranos com trancamento de matrícula com débito',
        paragraphs: [
          'Estudantes que já estavam em curso, trancaram a matrícula e possuem pendência financeira. A campanha deve ser trabalhada em conjunto com financeiro, secretaria acadêmica e retenção.',
          'O foco é recuperar o estudante antes que ele se torne evadido definitivo, apresentando uma solução que auxilie na regularização e permita retorno planejado ao curso. É uma campanha de alto valor estratégico porque combina recuperação de receita, redução de evasão e retomada de vínculo acadêmico.',
        ],
      },
      {
        title: 'Veteranos com trancamento de matrícula sem débito',
        paragraphs: [
          'Estudantes veteranos que trancaram a matrícula sem pendência financeira. A campanha deve ser trabalhada com foco em retorno acadêmico, principalmente antes do período de rematrícula. O melhor local de atuação é a base de trancados da secretaria acadêmica/registro acadêmico.',
          'O objetivo é entender a razão do trancamento e apresentar o crédito educacional como apoio para o retorno, especialmente quando o motivo estiver ligado à organização financeira, renda familiar ou insegurança de continuidade.',
        ],
      },
      {
        title: 'Veteranos em transferência para outra IES',
        paragraphs: [
          'Estudantes que sinalizaram intenção de transferência ou já iniciaram processo para sair da instituição. A campanha deve ser acionada rapidamente pela área de retenção, coordenação de curso ou relacionamento.',
          'O objetivo é atuar antes da perda definitiva do aluno, entendendo se a transferência está relacionada a preço, condições de pagamento, distância, insatisfação ou proposta concorrente. Quando a barreira for financeira, o crédito educacional pode ser apresentado como alternativa para permanência na IE.)',
        ],
      },
      {
        title: 'Veteranos evadidos sem débito',
        paragraphs: [
          'Estudantes que abandonaram ou deixaram de se rematricular sem pendências financeiras. A campanha deve atuar na base de evasão acadêmica, com foco em reativação e retorno. com mensagem de acolhimento, convite para retomada e possibilidade de simulação do crédito.',
          'Como não há débito, a abordagem deve priorizar o valor da continuidade do curso, a proximidade com a conclusão e a solução financeira para evitar nova interrupção.',
        ],
      },
      {
        title: 'Veteranos evadidos com débito',
        paragraphs: [
          'Estudantes que abandonaram ou deixaram de se rematricular e possuem pendências financeiras com a instituição.',
          'O foco é recuperar o vínculo e avaliar caminhos para retorno, considerando regularização, renegociação e eventual apoio por crédito educacional quando aplicável. É uma frente importante porque reduz perda de receita, melhora indicadores de evasão e pode recuperar alunos que ainda têm intenção de concluir o curso.',
        ],
      },
      {
        title: 'Veteranos matriculados/em curso sem débito',
        paragraphs: [
          'Estudantes ativos, regularmente matriculados e sem pendências financeiras. A campanha deve ser preventiva e atuar principalmente antes da rematrícula, no início do semestre ou em períodos de reajuste de mensalidade.',
          'O objetivo é apresentar o crédito educacional como ferramenta de permanência e planejamento financeiro, evitando que uma dificuldade futura leve à inadimplência, trancamento ou evasão.',
        ],
      },
      {
        title: 'Veteranos matriculados/em curso com débito',
        paragraphs: [
          'Estudantes ativos, ainda vinculados à instituição, mas com pendência financeira. A campanha deve ser priorizada porque o estudante ainda está em curso e pode ser retido antes de trancar ou evadir.',
          'O objetivo é oferecer uma alternativa de continuidade acadêmica, reduzindo o risco de evasão e ajudando a instituição a preservar matrícula, receita e relacionamento com o aluno.)',
        ],
      },
    ],
  },
  'Ex-alunos': {
    title: 'Ex-alunos',
    sections: [
      {
        title: 'Ex-alunos para segunda graduação ou pós-graduação',
        paragraphs: [
          'Público formado ou que já teve vínculo com a instituição e pode retornar para uma nova formação, segunda graduação, especialização ou pós-graduação. A campanha deve ser trabalhada com base de egressos e áreas de pós-graduação/educação continuada.',
          'O objetivo é gerar recompra educacional, aproveitando o vínculo prévio do estudante com a marca da IE e oferecendo o crédito como facilitador da continuidade dos estudos.',
        ],
      },
    ],
  },
  'FIES & PROUNI': {
    title: 'FIES e PROUNI',
    sections: [
      {
        title: 'FIES',
        paragraphs: [
          'Estudantes vinculados ao FIES, em lista de espera, não contemplados, contemplados parcialmente ou com necessidade de complemento financeiro. A campanha deve ser trabalhada principalmente no período de divulgação de resultados, lista de espera, rematrícula e fechamento de turmas.',
          'A abordagem deve apresentar a Fundacred como alternativa ou complemento ao FIES, especialmente quando o estudante já demonstrou necessidade de crédito para estudar. Há referência interna de campanhas para base de espera de FIES e mensagens para oferecer alternativa de crédito e aumentar adesão ao CredIES.',
        ],
      },
      {
        title: 'PROUNI',
        paragraphs: [
          'Estudantes vinculados ao PROUNI, em lista de espera, com bolsa parcial ou que não foram contemplados e ainda possuem interesse em estudar. A campanha deve atuar junto às áreas de bolsas, secretaria, captação e relacionamento, principalmente nos momentos de resultado, matrícula e rematrícula.',
          'O objetivo é oferecer o crédito educacional como alternativa ou complemento para viabilizar o ingresso ou a permanência do estudante.',
        ],
      },
    ],
  },
};
